import { z } from 'zod';
import { NOTIFICATION_CATEGORIES, NOTIFICATION_PAGE_SIZE, NOTIFICATION_SEVERITIES, } from '../constants/index.js';
import { idSchema, isoDateTimeSchema } from './common.js';
import { paginationMetaSchema } from './pagination.js';
import { whatsAppConversationSchema, whatsAppMessageSchema } from './whatsapp.js';
export const notificationCategorySchema = z.enum(NOTIFICATION_CATEGORIES);
export const notificationSeveritySchema = z.enum(NOTIFICATION_SEVERITIES);
export const notificationSchema = z.object({
    id: idSchema,
    category: notificationCategorySchema,
    severity: notificationSeveritySchema,
    title: z.string(),
    message: z.string(),
    linkUrl: z.string().nullable(),
    entityType: z.string().nullable(),
    entityId: z.string().nullable(),
    isRead: z.boolean(),
    readAt: isoDateTimeSchema.nullable(),
    createdAt: isoDateTimeSchema,
    /** Wahr, wenn die Meldung an alle Berechtigten adressiert ist. */
    isBroadcast: z.boolean(),
});
export const notificationListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(NOTIFICATION_PAGE_SIZE),
    category: notificationCategorySchema.optional(),
    severity: notificationSeveritySchema.optional(),
    unreadOnly: z.preprocess((value) => {
        if (value === 'true') {
            return true;
        }
        if (value === 'false') {
            return false;
        }
        return value;
    }, z.boolean().default(false)),
});
export const notificationListResponseSchema = z.object({
    data: z.array(notificationSchema),
    meta: paginationMetaSchema,
    unreadCount: z.number().int().min(0),
});
export const notificationUnreadCountSchema = z.object({
    unreadCount: z.number().int().min(0),
    criticalCount: z.number().int().min(0),
});
export const notificationReadAllResponseSchema = z.object({
    markedRead: z.number().int().min(0),
});
export const notificationPreferenceSchema = z.object({
    category: notificationCategorySchema,
    channelInApp: z.boolean(),
    channelEmail: z.boolean(),
});
export const notificationPreferenceListSchema = z.object({
    data: z.array(notificationPreferenceSchema),
});
export const notificationPreferenceUpdateSchema = z.object({
    preferences: z.array(notificationPreferenceSchema).min(1).max(NOTIFICATION_CATEGORIES.length),
});
/** Nutzlast eines Server-Sent-Event-Frames auf `/notifications/stream`. */
export const notificationStreamEventSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('ready'), unreadCount: z.number().int().min(0) }),
    z.object({
        type: z.literal('notification'),
        notification: notificationSchema,
        unreadCount: z.number().int().min(0),
    }),
    z.object({ type: z.literal('read'), unreadCount: z.number().int().min(0) }),
    /** Eingehende WhatsApp-Nachricht; hält die Team-Inbox ohne Abfrageschleife aktuell. */
    z.object({
        type: z.literal('whatsapp.message_received'),
        message: whatsAppMessageSchema,
        conversation: whatsAppConversationSchema,
    }),
    /** Zustellstufe einer ausgehenden Nachricht hat sich geändert. */
    z.object({
        type: z.literal('whatsapp.message_status'),
        messageId: idSchema,
        conversationId: idSchema,
        status: whatsAppMessageSchema.shape.status,
    }),
]);
//# sourceMappingURL=notification.js.map